module.exports = __webpack_public_path__ + "img/flower.036e761b.png";